import React from 'react';
import twitterX from "../../assets/x-twitter.svg";
import bluesky from "../../assets/bluesky.svg";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFacebookF, faInstagram, faLinkedinIn, faYoutube} from "@fortawesome/free-brands-svg-icons";

export default function Socials() {
    return (
        <div className="footer__social">
            <div className="footer__social-icons">
                <a href="https://twitter.com/nanopore" target="_blank"
                   className="footer__social-icon"><img src={twitterX} height="24"/></a>
                <a href="https://bsky.app/profile/nanoporetech.com" target="_blank"
                   className="footer__social-icon"><img src={bluesky} height="24"/></a>
                <a href="https://www.youtube.com/channel/UC5yMlYjHSgFfZ37LYq-dzig" target="_blank"
                   className="footer__social-icon"><FontAwesomeIcon icon={faYoutube}/></a>
                <a href="https://www.facebook.com/Oxford-Nanopore-Technologies-251034380246/"
                   target="_blank" className="footer__social-icon"><FontAwesomeIcon icon={faFacebookF}/></a>
                <a href="https://www.linkedin.com/company/oxford-nanopore-technologies"
                   target="_blank" className="footer__social-icon"><FontAwesomeIcon icon={faLinkedinIn}/></a>
                <a href="https://www.instagram.com/oxfordnanopore"
                   target="_blank" className="footer__social-icon"><FontAwesomeIcon icon={faInstagram}/></a>
            </div>
            <style jsx>{`
                .footer__social-icon {
                    padding: 0 1.125rem;
                    margin-right: 0;
                    opacity: 0.8;
                }
                .footer__social-icon:hover {
                    opacity: 1;
                }
            `}</style>
        </div>
    );
}
